import styled from 'styled-components';
import TextareaAutosize from 'react-autosize-textarea';

// NOTE - These styles are just to get this component inline with the Bootstrap style
const TextArea = styled(TextareaAutosize)`
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  resize: vertical;
`;

export default TextArea;
